export const strings = {
  "read_more": {
    "pt-br": "Leia mais",
    "en-us": "Read more"
  },
  "see_more": {
    "pt-br": "Veja mais",
    "en-us": "See more"
  },
  "see_less": {
    "pt-br": "Veja menos",
    "en-us": "See less"
  }
}
